module.exports = __webpack_public_path__ + "img/Group 105@2x.0dcb4fa8.png";